// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-btn[data-v-6eb0b2aa] {\n  position: absolute;\n  bottom: 0;\n  right: 10px;\n}\n.footer-btn button[data-v-6eb0b2aa] {\n  width: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
